// @ts-nocheck
/* eslint-disable */
export const appClose40Icon = {
    data: `<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28.4844 11.4854L11.5138 28.4559" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M11.5156 11.4854L28.4862 28.4559" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
    name: 'close-40' as const
};